/* eslint no-new: "off" */

import $ from "jquery";
import { setRequiredAttribute } from "./Service/ServiceFunctions";

class ControlUnitManager {
  /**
   * contain own HTML dom
   * @property
   * @type {Object}
   */
  $dom;

  /**
   * contain controller identifier
   * @property
   * @type {string}
   */
  controllerSelector = ".js-control-type";

  /**
   * contain software label identifier
   * @property
   * @type {string}
   */
  softwareLabel = ".js-software-label";

  /**
   * contain unit value identifier
   * @property
   * @type {string}
   */
  controlUnitValue = ".js-control-value";

  /**
   * contain software identifier
   * @property
   * @type {string}
   */
  softwareSelector = ".js-control-software";

  /**
   * enable software observer
   * @property
   * @type {Boolean}
   */
  softwareObserver = false;

  /**
   * contain controller value
   * @property
   * @type {String}
   */
  controllerValue = "";

  /**
   * contain software value
   * @property
   * @type {String}
   */
  softwareValue = "";

  machineryControllerJson = [];

  /**
   * controlUnitManager constructor
   * @method constructor
   */
  constructor(element) {
    this.$dom = element;

    let machineryControllerJson = element.data("machinery-controller-json");

    if (typeof machineryControllerJson === "string") {
      machineryControllerJson = JSON.parse(machineryControllerJson);
    }
    this.machineryControllerJson = machineryControllerJson;

    setRequiredAttribute(this.$dom, ".js-required");
    this.observer();
  }

  /**
   * observes controller- and software select
   * @method observer
   */
  observer() {
    this.$dom.find(this.controllerSelector).on("change", (e) => {
      this.controllerValue = $(e.currentTarget).val();
      this.removeFormValue();

      if (
        this.controllerValue.length &&
        Object.prototype.hasOwnProperty.call(
          this.machineryControllerJson,
          this.controllerValue
        )
      ) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.machineryControllerJson[this.controllerValue],
            "software"
          )
        ) {
          if (this.machineryControllerJson[this.controllerValue].software) {
            this.setSoftwareValues();
            this.enableSoftwareSelector();
            this.softwareObserver = true;
          }
        }
      } else {
        this.disableSoftwareSelector();
        this.softwareObserver = false;
      }
    });

    this.$dom.find(this.softwareSelector).on("change", (e) => {
      this.softwareValue = $(e.currentTarget).val();
      this.setFormValue();
    });
  }

  /**
   * set all software versions depending on controller
   * @method setSoftwareValues
   */
  setSoftwareValues() {
    this.softwareSelectorValueCleanUp();
    Object.keys(
      this.machineryControllerJson[this.controllerValue].software
    ).forEach((software) => {
      if (software.length) {
        this.$dom.find(this.softwareSelector).append(
          $("<option>", {
            value: software,
            text: software,
          })
        );
      }
    });
  }

  /**
   * remove property disable and add property required
   * @method enableSoftwareSelector
   */
  enableSoftwareSelector() {
    this.$dom
      .find(this.softwareSelector)
      .prop("disabled", false)
      .prop("required", true);
  }

  /**
   * add property disable and remove property required
   * @method disableSoftwareSelector
   */
  disableSoftwareSelector() {
    this.removeFormValue();
    $(this.$dom.find(this.softwareSelector))
      .prop("disabled", true)
      .prop("required", false);
    this.softwareSelectorValueCleanUp();
  }

  /**
   * remove values and set label
   * @method softwareSelectorValueCleanUp
   */
  softwareSelectorValueCleanUp() {
    const label = $(this.$dom.find(this.softwareLabel)).html();
    $(this.$dom.find(this.softwareSelector)).empty().append(label);
  }

  /**
   * @method removeFormValue
   */
  removeFormValue() {
    this.$dom.find(this.controlUnitValue).prop("value", "");
  }

  /**
   * set/ remove transmission form value
   * @method setFormValue
   */
  setFormValue() {
    if (this.softwareObserver) {
      if (this.controllerValue.length === 0 || this.softwareValue === "") {
        this.removeFormValue();
      } else {
        this.$dom
          .find(this.controlUnitValue)
          .prop(
            "value",
            `${this.controllerValue} Software: ${this.softwareValue}`
          );
      }
    }
  }
}

(function formManager() {
  $("[data-control-unit]").each((idx, item) => {
    new ControlUnitManager($(item));
  });
})();
